import apiClient from "./config";

const newsService = {
  // Get all news
  getAllNews: async () => {
    try {
      const response = await apiClient.get("/news");
      return response.data.news || [];
    } catch (error) {
      console.error(
        "Error in getAllNews:",
        error.response?.data || error.message
      );
      throw new Error(error.response?.data?.message || "Failed to fetch news");
    }
  },

  // Get news by ID
  getNewsById: async (newsId) => {
    try {
      const response = await apiClient.get(`/news/${newsId}`);
      console.log("Service getNewsById response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Error in getNewsById:",
        error.response?.data || error.message
      );
      throw new Error(
        error.response?.data?.message || "Failed to fetch news details"
      );
    }
  },

  // Create new news
  createNews: async (newsData) => {
    try {
      const response = await apiClient.post("/news", newsData);
      return response.data.news;
    } catch (error) {
      console.error(
        "Error in createNews:",
        error.response?.data || error.message
      );
      throw new Error(error.response?.data?.message || "Failed to create news");
    }
  },

  // Update news
  updateNews: async (newsId, newsData) => {
    try {
      const response = await apiClient.put(`/news/${newsId}`, newsData);
      return response.data.news;
    } catch (error) {
      console.error(
        "Error in updateNews:",
        error.response?.data || error.message
      );
      throw new Error(error.response?.data?.message || "Failed to update news");
    }
  },

  // Delete news
  deleteNews: async (newsId) => {
    try {
      const response = await apiClient.delete(`/news/${newsId}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error in deleteNews:",
        error.response?.data || error.message
      );
      throw new Error(error.response?.data?.message || "Failed to delete news");
    }
  },
};

export default newsService;
